import { useTranslation } from "react-i18next"

interface ITranslatedTextProps {
  text: string
}

const TranslatedText = (props: ITranslatedTextProps) => {
  const { t } = useTranslation()

  return <>{t(props.text)}</>
}

export default TranslatedText
